import React, { useState, useContext, useEffect } from "react";
import logo from "../../assets/navbar/asaxiy-logo.svg";
import SearchIcon from "@mui/icons-material/Search";
import "../../index.css";
import SideBar from "./SideBar";
import ShoppingCart from "./BodyData/ShoppingCart";

// Icons:
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LanguageIcon from "@mui/icons-material/Language";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

// Increment like count:
import { LikeCountContext } from "./BodyData/LikeNumbers";
import { CartCountContext } from "./BodyData/CartNumbers.js";

// let cartCount = 0;

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [textColor, setTextColor] = useState("text-textBlack");
  const [iconColor, setIconColor] = useState("text-textBlack");
  const [selectedLanguage, setSelectedLanguage] = useState("O'zbek tili");
  const [showLanguageOptions, setShowLanguageOptions] = useState(false);

  const { likeCount } = useContext(LikeCountContext);
  const { cartCount } = useContext(CartCountContext);

  // Increase like numbers

  function toggleMenu() {
    setMenuOpen(!menuOpen);
    setTextColor(menuOpen ? "text-textBlack" : "text-blueColor");
  }

  const [showTooltip, setShowTooltip] = useState(false);

  const handleTooltipMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleTooltipMouseLeave = () => {
    setTimeout(() => {
      setShowTooltip(false);
    }, 1500);
  };

  const handleLanguageIconClick = () => {
    setShowLanguageOptions(!showLanguageOptions);
  };

  const handleLanguageOptionClick = (language) => {
    setSelectedLanguage(language);
    setShowLanguageOptions(false);
  };

  // Sroll bar:
  useEffect(() => {
    if (menuOpen) {
      document.documentElement.classList.add("overflow-hidden");
    } else {
      document.documentElement.classList.remove("overflow-hidden");
    }
  }, [menuOpen]);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <div>
      <nav className="bg-contentBg flex flex-col items-center w-screen border-2">
        <div className="z-1 p-2 border-b-1 flex container-xl befSmall:flex-col w-full justify-around items-center">
          {/* First Div */}
          <div className="flex justify-between items-center befSmall:w-full">
            <a href="#" className="flex items-center text-white">
              <img
                className="object-contain h-auto w-auto"
                src={logo}
                alt="Logo"
              />
            </a>

            <div className="afSmall:hidden">
              <a href="#" onClick={toggleMenu}>
                {menuOpen ? (
                  <CloseIcon fontSize="large" className={`${textColor} mr-3`} />
                ) : (
                  <MenuIcon fontSize="large" className={`${textColor} mr-3`} />
                )}
              </a>
            </div>
          </div>

          {/* Second Div */}
          <div className="flex items-center bg-blueColor rounded-lg border-2 border-blueColor w-2/5 h-full befSmall:w-full mt-1 sm:mt-0">
            <input
              type="text"
              className="text-blueColor mediumFont p-2 text-xxl w-full sm:w-auto border border-gray-300 rounded-lg focus:outline-none"
              placeholder="Search..."
            />

            <button className="round-right-lg text-white flex items-center px-3 sm:px-4 py-2 sm:py-1">
              <SearchIcon />
              Search
            </button>
          </div>

          {/* Third Div */}
          <div className="befSmall:hidden flex justify-evenly mediumFont w-2/5">
            <a
              href="#"
              className="text-textBlack flex flex-col items-center justify-center hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg xl:text-xl xxl:text-xxl"
            >
              <CreditCardIcon fontSize="large" />
              <span className="mt-1">To'lov</span>
            </a>

            <a
              href="#"
              className="text-textBlack flex flex-col items-center justify-center hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg xl:text-xl xxl:text-xxl"
            >
              <LocalShippingIcon fontSize="large" />
              <span className="mt-1">Trek</span>
            </a>

            <a
              href="#"
              className="text-textBlack flex flex-col rounded-lg items-center justify-center hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg xl:text-xl xxl:text-xxl"
              onClick={handleLanguageIconClick}
            >
              <LanguageIcon fontSize="large" />
              <span className="mt-1">{selectedLanguage}</span>
              {showLanguageOptions && (
                <div className="absolute z-10 top-10 w-32 text-center bg-whiteSmoke rounded-lg shadow">
                  <a
                    href="#"
                    className="block bg-whiteSmoke py-1 rounded-lg text-black hover:text-blueColor transition-colors duration-200"
                    onClick={() => handleLanguageOptionClick("Rus tili")}
                  >
                    Rus tili
                  </a>
                  <a
                    href="#"
                    className="block bg-whiteSmoke py-1 rounded-lg text-black hover:text-blueColor transition-colors duration-200"
                    onClick={() => handleLanguageOptionClick("O'zbek tili")}
                  >
                    O'zbek tili
                  </a>
                  <a
                    href="#"
                    className="block bg-whiteSmoke py-1 rounded-lg text-black hover:text-blueColor transition-colors duration-200"
                    onClick={() => handleLanguageOptionClick("Ingliz tili")}
                  >
                    Ingliz tili
                  </a>
                </div>
              )}
            </a>

            <a
              href="#"
              className="text-textBlack flex flex-col items-center justify-center hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg xl:text-xl xxl:text-xxl"
            >
              <div className="relative">
                <button>
                  {likeCount > 0 ? (
                    <span className="absolute top-1 right-1 -mt-2 -mr-2">
                      <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-blueColor">
                        <span className="text-white sm:text-xs md:text-sm lg:text-base xl:text-sm xxl:text-sm font-medium">
                          {likeCount}
                        </span>
                      </span>
                    </span>
                  ) : (
                    <span className="absolute top-1 right-1 -mt-2 -mr-2">
                      <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-blueColor">
                        <span className="text-white sm:text-xs md:text-sm lg:text-base xl:text-lg xxl:text-xl font-medium">
                          0
                        </span>
                      </span>
                    </span>
                  )}
                  <FavoriteBorderIcon fontSize="large" />
                </button>
              </div>
              <span className="mt-1">Sevimlilar</span>
            </a>

            <div className="relative">
              <a
                href="#"
                className="text-textBlack flex flex-col items-center justify-center hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg xl:text-xl xxl:text-xxl"
                onMouseEnter={handleTooltipMouseEnter}
                // onMouseLeave={handleTooltipMouseLeave}
              >
                <div className="relative">
                  <button>
                    {cartCount > 0 ? (
                      <span className="absolute top-1 right-1 -mt-2 -mr-2">
                        <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-blueColor">
                          <span className="text-white sm:text-xs md:text-sm lg:text-base xl:text-sm xxl:text-sm font-medium">
                            {cartCount}
                          </span>
                        </span>
                      </span>
                    ) : (
                      <span className="absolute top-1 right-1 -mt-2 -mr-2">
                        <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-blueColor">
                          <span className="text-white sm:text-xs md:text-sm lg:text-base xl:text-lg xxl:text-xl font-medium">
                            0
                          </span>
                        </span>
                      </span>
                    )}
                    <ShoppingCartIcon fontSize="large" />
                  </button>
                </div>
                <span className="mt-1">Savatcha</span>
              </a>
              {showTooltip && (
                <div
                  className="absolute bg-whiteBlue right-4 w-80 h-56 top-20 z-10 rounded-lg shadow"
                  onMouseEnter={handleTooltipMouseEnter}
                  onMouseLeave={handleTooltipMouseLeave}
                >
                  <ShoppingCart />
                </div>
              )}
            </div>

            <a
              href="#"
              className="text-textBlack flex flex-col items-center justify-center hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg xl:text-xl xxl:text-xxl"
            >
              <PermIdentityIcon fontSize="large" />
              <span className="mt-1">Kabinet</span>
            </a>
          </div>
        </div>

        {/* Pastki Navbar */}
        <div className="z-1 mediumFont befSmall:hidden container-xl flex w-full justify-around items-center border-t-2 py-3 shadow-xl">
          {/* Create here menu button */}
          <a
            className={`hamburger-btn ${textColor} hover:text-blueColor transition duration-500 ease-in-out relative sm:text-sm md:text-md lg:text-lg xl:text-xl xxl:text-xxl`}
            href="#"
            onMouseEnter={() => setIconColor("text-blueColor")}
            onMouseLeave={() => setIconColor("text-textBlack")}
            onClick={toggleMenu}
          >
            {menuOpen ? (
              <CloseIcon fontSize="large" className={`${textColor} mr-3`} />
            ) : (
              <MenuIcon fontSize="large" className={`${iconColor} mr-3`} />
            )}
            Barcha bo'limlar
          </a>

          <a
            className="text-textBlack hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg"
            href="#"
          >
            Chegirmalar
          </a>
          <a
            className="text-textBlack hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg"
            href="#"
          >
            Konditsionerlar
          </a>
          <a
            className="text-textBlack hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg"
            href="#"
          >
            Yangi kelganlar
          </a>
          <a
            className="text-textBlack hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg"
            href="#"
          >
            Kitoblar
          </a>
          <a
            className="text-textBlack hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg"
            href="#"
          >
            Telefonlar va Gadjetlar
          </a>
          <a
            className="text-textBlack hover:text-blueColor transition duration-200 ease-in relative sm:text-sm md:text-md lg:text-lg"
            href="#"
          >
            Notubuklar
          </a>
        </div>

        {/* Sidebar */}
      </nav>

      <div
        className={`${
          menuOpen
            ? "translate-x-0 duration-200 ease-out"
            : "-translate-x-full duration-200 ease-in"
        }`}
      >
        {menuOpen && <SideBar />}
      </div>
    </div>
  );
}

export default Navbar;
